export default __webpack_public_path__ + "images/ZZ.27b6cba.png";